module.exports = __webpack_public_path__ + "static/media/glass1.90c3a2dd.jpg";